function NotificationError() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g id="style=fill">
          <g id="error-box">
            <path
              id="Subtract"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.25 8C1.25 4.27208 4.27208 1.25 8 1.25L16 1.25C19.7279 1.25 22.75 4.27208 22.75 8L22.75 16C22.75 19.7279 19.7279 22.75 16 22.75L8 22.75C4.27208 22.75 1.25 19.7279 1.25 16L1.25 8ZM8.46967 8.46966C8.76257 8.17676 9.23744 8.17677 9.53033 8.46966L12 10.9393L14.4697 8.46966C14.7626 8.17676 15.2374 8.17677 15.5303 8.46966C15.8232 8.76256 15.8232 9.23743 15.5303 9.53032L13.0606 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7625 15.8232 14.4696 15.5303L12 13.0606L9.53033 15.5303C9.23743 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7625 8.46967 14.4696L10.9393 12L8.46967 9.53032C8.17678 9.23742 8.17678 8.76255 8.46967 8.46966Z"
              fill="#000000"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default NotificationError;
